import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  
  FaFacebookF,
  FaLocationDot,
  FaPhone,
  FaEnvelope,
  FaXmark,
  FaBars,
  FaLinkedinIn,

} from "react-icons/fa6";

import SchoolLogo from "./SchoolLogo";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar-wrapper">
      {/* ===== TOP INFO BAR ===== */}
      <div className="top-bar">
        <div className="top-bar-left">
          <span><FaLocationDot /> Office Address - Liberia: 1st Floor Sekou House Capitol Bye Pass Adjacent BMC Stores </span>
          <span><FaPhone /> +231 881 924 553 / +231 777 777 510 </span>
          <span><FaEnvelope /> info@ugaaliberia.org </span>
        </div>

        <div className="top-bar-right">
          
        <a href="https://www.facebook.com/profile.php?id=61583738435863" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>
        <a href="https://www.linkedin.com/company/ugaa-liberia" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn />
        </a>
          
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <nav className="main-navbar">
        {/* LOGO */}
        <NavLink to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <SchoolLogo />
        </NavLink>

        {/* NAV LINKS */}
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>

          <div className="dropdown">
            <span>About Us</span>
            <div className="dropdown-menu">
              <NavLink to="/about-association" onClick={() => setMenuOpen(false)}>The Association</NavLink>
              <NavLink to="/mission-vision" onClick={() => setMenuOpen(false)}>Mission & Vision</NavLink>
              <NavLink to="/leadership" onClick={() => setMenuOpen(false)}>Leadership</NavLink>
            </div>
          </div>

          <div className="dropdown">
            <span>Our Activities</span>
            <div className="dropdown-menu">
              <NavLink to="/projects" onClick={() => setMenuOpen(false)}>Projects</NavLink>
              <NavLink to="/news-events" onClick={() => setMenuOpen(false)}>Events & News</NavLink>
              <NavLink to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</NavLink>
            </div>
          </div>

          <div className="dropdown">
            <span>Get Involved</span>
            <div className="dropdown-menu">
              <NavLink to="/membership" onClick={() => setMenuOpen(false)}>Become a Member</NavLink>
              <NavLink to="/support" onClick={() => setMenuOpen(false)}>Support a Project</NavLink>
            </div>
          </div>

          <div className="dropdown">
            <span>Jobs & Mentorship</span>
            <div className="dropdown-menu">
              <NavLink to="/jobs&internship" onClick={() => setMenuOpen(false)}>Jobs & Internship</NavLink>
               <NavLink to="/alumni-talent-pool" onClick={() => setMenuOpen(false)}>Alumni Talent Pool</NavLink>
              <NavLink to="/mentorship" onClick={() => setMenuOpen(false)}>Mentorship</NavLink>
             
            </div>
          </div>

          <NavLink to="/contact-us" onClick={() => setMenuOpen(false)}>Contact Us</NavLink>
        </div>

        {/* TOGGLE BUTTON (SAME POSITION) */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FaXmark /> : <FaBars />}
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
